import ProductsApi from "@/api/products/";

export default {
  namespaced: true,

  state: {
    allProducts: [],
    selectedProduct: {},
    selectedProductImages: [],
    selectedProductTerpenes: []
  },

  getters: {
    allProducts: state => state.allProducts,
    selectedProduct: state => state.selectedProduct,
    selectedProductImages: state => state.selectedProductImages,
    selectedProductTerpenes: state => state.selectedProductTerpenes
  },

  mutations: {
    setAllProducts(state, products) {
      state.allProducts = products;
    },

    setSelectedProduct(state, product) {
      state.selectedProduct = product;
    },

    setSelectedProductImages(state, images) {
      state.selectedProductImages = images;
    },

    setSelectedProductTerpenes(state, payload) {
      state.selectedProductTerpenes = payload;
    }
  },

  actions: {
    async fetchAllProducts({ commit }) {
      commit("Spinner/setSpinnerStatus", true, { root: true });
      return ProductsApi.getProducts(true)
        .then(res => {
          const featuredProducts = res.data.payload.filter(
            product => product.featured === true
          );
          commit("setAllProducts", featuredProducts);
          commit("Spinner/setSpinnerStatus", false, { root: true });
        })
        .catch(err => {
          commit("setAllProducts", []);
          commit("Spinner/setSpinnerStatus", false, { root: true });
          return err;
        });
    },

    async fetchProduct({ commit }, productId) {
      commit("Spinner/setSpinnerStatus", true, { root: true });
      return ProductsApi.getProduct(productId)
        .then(res => {
          commit("setSelectedProduct", res.data.payload);
          commit("Spinner/setSpinnerStatus", false, { root: true });
        })
        .catch(err => {
          commit("setSelectedProduct", {});
          commit("Spinner/setSpinnerStatus", false, { root: true });
          return err;
        });
    },

    async fetchProductImages({ commit }, productId) {
      commit("Spinner/setSpinnerStatus", true, { root: true });
      return ProductsApi.getProductImages(productId)
        .then(res => {
          commit("setSelectedProductImages", res.data.payload);
          commit("Spinner/setSpinnerStatus", false, { root: true });
        })
        .catch(err => {
          commit("setSelectedProductImages", []);
          commit("Spinner/setSpinnerStatus", false, { root: true });
          return err;
        });
    },

    async fetchProductTerpenes({ commit }, productId) {
      commit("Spinner/setSpinnerStatus", true, { root: true });
      return ProductsApi.getProductTerpenes(productId)
        .then(res => {
          commit("setSelectedProductTerpenes", res.data.payload);
          commit("Spinner/setSpinnerStatus", false, { root: true });
        })
        .catch(err => {
          commit("setSelectedProductTerpenes", []);
          commit("Spinner/setSpinnerStatus", false, { root: true });
          return err;
        });
    }
  }
};
